/* eslint-disable no-unused-vars */
import { axios } from './index'

const resource = '/v1/stay'

export default {

  getBenePoint() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/member/point`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.error)
        }
      )
    })
  }
}